import { Station } from 'dataSources/Typicode/stations';
import { IconButton, Tooltip } from 'e100-react-components';
import { useSelectedStationOnRoute, useStationsOperations } from 'entities/stations';
import React from 'react';
import { useIntl } from 'react-intl';

const MAX_STATIONS_ON_ROUTE = 8;

export const AddSelectedStationButton = ({ station }: AddSelectedStationButtonProps) => {
  const { formatMessage } = useIntl();
  const { updateSelectedStationOnRoute } = useStationsOperations();
  const selectedStations = useSelectedStationOnRoute();
  const isSleetedMaxStation = (selectedStations?.length ?? 0) >= MAX_STATIONS_ON_ROUTE;

  const onAddHandler = (e: React.MouseEvent) => {
    e.stopPropagation();
    updateSelectedStationOnRoute([station.code]);
  };

  return (
    <Tooltip
      title={
        isSleetedMaxStation ? formatMessage({ id: 'maxStationsOnRoute' }) : formatMessage({ id: 'addStationOnRoute' })
      }
      placement="top"
    >
      <IconButton disabled={isSleetedMaxStation} kind="add" color="secondary" onClick={onAddHandler} />
    </Tooltip>
  );
};

interface AddSelectedStationButtonProps {
  station: Station;
}
